module.exports = __webpack_public_path__ + "static/media/waving_hand_icon.c35761d2.svg";